"use strict";
angular.module('eventAnalysisDetailModule', []).controller('eventAnalysisDetailCtrl', ['$scope',"$rootScope","$stateParams","$filter","trsHttpService", "$timeout", "$state","$q", "dateFilter","eventAnalysisService",
    function($scope,$rootScope,$stateParams,$filter,trsHttpService, $timeout, $state,$q, dateFilter,eventAnalysisService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
       function initStatus(){
           $scope.status={
               id:$stateParams.id,
               selectedMediaGroup:'zhihu',
               selectedGuideInfo:'all',
               selectedOpinionAna:'person',
               activeIndex:0,
               basicInfoRelateList:[
                   {name:'相关机构',field:"ENTITY_ORG"},
                   {name:'相关人物',field:"ENTITY_NAME"},
                   {name:'相关地点',field:"ENTITY_PLACE"}
               ],
               mockGuidePicData:[],
               selectedGuideInfoIndex:0,
               selectedViewPointerIndex:0,
               mediaChannel:{
                   '客户端':'app',
                   '网站':'wz',
                   '数字报':'szb',
                   '微信':'wx'
               },
               currentPage:1,
               showEventSkeletonTime:0,
               isFirstLoad:true,
               removeRepetitionData:'排重',
               choiceKeyWord:'',
               disabledEntityArticle:true,
               choiceChannelInit:0,
               innerIndex:0,
           };
           $scope.data={
               CarouselData : [],
               hotWordData:[],
               viewpoinManuData:[],
               currentPropRelate:0,
           };
           //基本信息请求
            $scope.basicInfoParams={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'briefIntroduction',
                eventid: $scope.status.id,
            };
            //基本相关列表
            $scope.basicInfoRelateListParams={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'relatedentity',
                type:1,
                eventid: $scope.status.id,
            };
            //基本信息-突发事件
            $scope.basicInfoBreakNewParams={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'breaknews',
                eventid: $scope.status.id,
            };
            //基本信息-知识图谱
            $scope.basicInfoDepartmentParams={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'department',
                eventid: $scope.status.id,
            };
            //事件脉络分析-事件脉络分析
            $scope.eventSkeletonAnalyS={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'viewpointlist',
                eventid: $scope.status.id,
                pubtime:''
            };
            //事件脉络分析 时间列表
            $scope.eventSkeletonAnalyTime={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'geteventtime',
                eventid: $scope.status.id,
            };
            //事件传播分析曲线图
            $scope.eventPropAnalysisLine={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'spreadcount',
                eventid: $scope.status.id,
            };
            //事件传播分析相关稿件
            $scope.eventPropRelateManus={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'relatedocs',
                search_date:'',
                eventid: $scope.status.id,
            };
            //事件传播分析-渠道分类及主要传播渠道
            $scope.eventPropRelateQu={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'mainchannel',
                eventid: $scope.status.id,
                md5tag:''
            };
            //事件传播分析-归属性质及首发媒体
            $scope.eventPropRelateMedia={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'channeldetails',
                eventid: $scope.status.id,
                channel:'',
                md5:""
            };
            //事件传播分析-声量占比
            $scope.eventPropProportion={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'volume',
                eventid: $scope.status.id,
                md5:''
            };
            //事件观点分析 事件观点分类-导航栏
            $scope.eventViewpointAnaNav={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getcommentcategory',
                eventid: $scope.status.id,
            };
            //事件观点分析-对应导航下的实体排序
            $scope.eventViewpointEntity={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getcommententity',
                eventid: $scope.status.id,
                category:''
            };
            //事件观点分析-实体对应文章
            $scope.eventViewpointEntityArticle={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getabstracts',
                eventid: $scope.status.id,
                category:'',
                entity:'',
                page_size:'15',
                page_no:$scope.status.currentPage-1,
                type:"",
            };
            //事件观点分析-文章渠道导航栏
            $scope.eventViewpointerArticleChannel={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getchannels',
                eventid: $scope.status.id,
            };
            //事件情感分析-情感变化曲线图
            $scope.eventEmotionChange={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'emotion',
                eventid: $scope.status.id
            };
            //事件情感分析-情感变化关键词
            $scope.eventSpreadKeyword={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'emotionkeywords',
                eventid: $scope.status.id,
                search_date:''
            };
            //事件情感分析分析-情感主导媒体
            $scope.eventSpreadEmotionMedia={
                typeid: 'event',
                serviceid: 'eventdetail',
                modelid:'emotionmedia',
                eventid: $scope.status.id,
                search_date:''
            };
            //观点分析-观点导航栏
            $scope.viewpointInfoAnaNav={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getviewcategory',
                eventid: $scope.status.id
            };
            //观点分析-观点占比饼图
            $scope.viewpointProportion={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'viewpercent',
                eventid: $scope.status.id,
                slaveid:'',
            };
            //观点分析-事件观点转载量统计曲线图
            $scope.viewpoinTransport={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getmediagraph',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
           // 观点分析-情感变化关键词
            $scope.viewpoinEmotionKeyword={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getemotionkeywords',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
            //观点分析-观点文章排行
            $scope.viewpoinArticleRank={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getviewpoint',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
            //观点分析-传播数据结果分析-主要渠道
            $scope.viewpoinSpreadData={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getmainchannel',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
            //观点分析-传播数据结果分析-主力媒体
            $scope.viewpoinSZMedia={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getorginalmedia',
                field:'official_data',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
           //观点分析-传播数据结果分析-引爆观点
            $scope.viewpoinDetonateGuide={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getdetonatemedia',
                field:'official_data',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
            //观点分析-传播数据结果分析-峰值时间
            $scope.viewpoinPeakTime={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'gettopdocpubtime',
                field:'official_data',
                eventid: $scope.status.id,
                type:'official',
                slaveid:'',
            };
            //观点稿件
            $scope.viewpoinManuscript={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getrelateddoc',
                slaveid:'',
                eventid: $scope.status.id
            };
            //观点图片
            $scope.viewpoinPic={
                typeid: 'event',
                serviceid: 'eventtrace',
                modelid:'getrelatedpic',
                eventid: $scope.status.id,
                page_size:'20'
            };

       };
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
       function initData(){
             requestData();
             basicInfoRelateList();
       }
        /**
         * [requestData description] 基本信息数据
         * @return {[type]} [description]
         */
        function requestData(){
            getEventPropRelateMenus('');
            //基本信息请求
            $scope.loadingPromise= trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.basicInfoParams, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.basicInfoDataInit=data;
                    $scope.data.CarouselData=data.IMAGEURL.split(";");
                    $scope.data.CarouselData.pop();
                }
            });
            //基本信息-突发事件
            $scope.loadingPromise= trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.basicInfoBreakNewParams, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.breakNew=data.replace(/\"/g,"");
                }
            });
            //基本信息-知识图谱
            $scope.loadingPromise= trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.basicInfoDepartmentParams, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.department=data;
                    $scope.department.FIRSTORG=data.FIRSTORG.slice(0,data.FIRSTORG.length-1);
                }
            });
            //事件脉络分析 时间列表
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventSkeletonAnalyTime, "GET").then(function(data) {
                $scope.eventSkeletonAnalyTimeDataArr=[];
                if(angular.isDefined(data)){
                    $scope.eventSkeletonAnalyTimeData=data.replace(/\"/g,"").split(";");
                    $scope.eventSkeletonAnalyTimeData.reverse();
                    $scope.eventSkeletonAnalyTimeData.map(function(value,key){
                        if(key==0){
                            value=value.replace(/\s+/g, "");
                        }
                        value=value.split("-");
                        value=value[0]+'年'+value[1]+'月'+value[2]+'日';
                        $scope.eventSkeletonAnalyTimeDataArr.push(value);
                        return $scope.eventSkeletonAnalyTimeDataArr;
                    });
                    $scope.eventSkeletonAnalyS.pubtime=$scope.eventSkeletonAnalyTimeData[0].replace(/\s+/g, "");
                    getEventSkeletonAnalyS();
                }
            });
            //事件传播分析曲线图
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventPropAnalysisLine, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.eventPropAnalysisLineData=data;
                }
            });
            //事件观点分析 事件观点分类-导航栏
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventViewpointAnaNav, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    var fieldObj={
                        '关键词':'KEYWORDS',
                        '人物':'ENTITY_NAME',
                        '机构':'ENTITY_ORG',
                        '关注媒体':'ZB_SOURCE_SITE',
                    };
                    $scope.viewPointerAnaNav=data.map(function(item,index){
                        var obj={
                            STRVALUE:item.STRVALUE,
                            IRECORDNUM:item.IRECORDNUM,
                            IVALIDNUM:item.IVALIDNUM,
                            field:fieldObj[item.STRVALUE],
                        };
                        return obj;
                    });
                    $scope.eventViewpointEntity.category=data[0].STRVALUE;
                    $scope.eventViewpointEntityArticle.category=data[0].STRVALUE;
                    getEventViewpointEntity();
                }
            });
            //事件观点分析-文章渠道导航栏
            getViewpointerArticleChannel();
            //事件情感分析-情感变化曲线图
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventEmotionChange, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    data= angular.fromJson(JSON.parse(data));
                    $scope.emotionChangeChart=data;
                    $scope.emotionChangeStrTime= $filter('date')(new Date($scope.emotionChangeChart[0][0].date), 'MM-dd');
                    $scope.emotionChangEndTime= $filter('date')(new Date($scope.emotionChangeChart[$scope.emotionChangeChart.length-1][0].date), 'MM-dd');
                }
            });
            //事件情感分析-情感变化关键词
            getEventSpreadKeyword();
            //事件情感分析-情感主导媒体
            getEventSpreadEmotionMedia();
            // 观点分析-观点导航栏
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.viewpointInfoAnaNav, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.data.viewpointAnaNavData=data;
                    getViewPointerPro(data[0].ID);
                }
            });
            //观点稿件
            getViewpoinManuscriptData();
            //观点图片
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinPic, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewPointPicData=data.PAGEITEMS;
                    var picData=[];
                    for(var i=0;i<$scope.viewPointPicData.length;i++){
                        if($scope.viewPointPicData[i].SRCLINK){
                            picData.push({picUrl:$scope.viewPointPicData[i].SRCLINK});
                        }
                    }
                    $scope.status.mockGuidePicData=picData;
                }
            });


        }

        /**
         * [getViewpointerArticleChannel description] 文章渠道导航栏
         * @return {[type]} [description]
         */
        function getViewpointerArticleChannel(){
            var defer=$q.defer();
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),    $scope.eventViewpointerArticleChannel, "GET").then(function(data) {
                $scope.eViewPointerArticleChannelData=data;
                defer.resolve(data);
            });
            return defer.promise;
        }
        /**
         * [changeArticleChannel description] 文章渠道导航栏我切换
         */
        $scope.changeArticleChannel=function(index){
            $scope.status.choiceChannelInit=index;
            $scope.eventViewpointEntityArticle.type=$scope.eViewPointerArticleChannelData[index].type;
            eventViewpointEntityArticle();
        };
        /**
         *观点稿件
         */
        function getViewpoinManuscriptData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinManuscript, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.data.viewpoinManuData=data;
                }
            });
        };
        /**
         * 去除文章中的空格
         */
        $scope.removeSpace=function(content){
            var reg=/(^\s+)|(\s+$)|\s+/g;
            return content.replace(reg,"");
        };
        /**
         * 事件列表下钻页
         * @param index
         */
        $scope.toNewList=function(data,field){
            if(data=='-'){
                return;
            }else{
                $state.go("front.plan.eventanalysis.newlist",{id:$scope.status.id,keyword:data,field:field});
            }
        };
        //选择相关热点关键词
        $scope.selectedHotWord=function(index){
            $scope.status.activeIndex=index;
            $scope.basicInfoRelateListParams.type=index+1;
            $scope.data.hotWordData=[];
            basicInfoRelateList();
        };
        //相关机构  相关地点  相关人物
        function basicInfoRelateList(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.basicInfoRelateListParams, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.data.hotWordData=data.splice(1,9);
                }
            });
        };
        //事件脉络分析
        $scope.eventSkeletonTime=function(index){
            $scope.status.showEventSkeletonTime = index;
            $scope.eventSkeletonAnalyS.pubtime = $scope.eventSkeletonAnalyTimeData[index].replace(/\s+/g, "");
            getEventSkeletonAnalyS();
        };
        function getEventSkeletonAnalyS(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventSkeletonAnalyS, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.eventSkeletonAnalySData=data;
                }
            });
        }
        //事件传播
        $scope.$on("changeTimeRangeData",function(event,value){
            var timeValue=value.timeValue;
            var staTime=$filter('date')(new Date(timeValue.startValue), 'yyyy-MM-dd');
            var endTime=$filter('date')(new Date(timeValue.endValue), 'yyyy-MM-dd');
            if(staTime== $scope.emotionTimeStartTime&&endTime==$scope.emotionTimeEndTime){
                return;
            }
            $scope.spreadTimeStartTime=staTime;
            $scope.spreadTimeEndTime=endTime;
            var searchDate=$scope.spreadTimeStartTime
                +';'+$scope.spreadTimeEndTime;
            $scope.eventPropRelateManus.search_date=searchDate;
            getEventPropRelateMenus();
        });
        $scope.$on("changeChannel",function(event,value){
            var channelValue = value.channel;
            $scope.status.innerIndex=value.innerIndex;
            $scope.eventPropRelateMedia.channel = channelValue;
            $scope.status.isFirstLoad=false;
            getEventPropRelateQu();
        });
        $scope.removeRepetition=function(value){
            $scope.status.removeRepetitionData=value=='已排重'?'排重':'已排重';
            $scope.viewpoinEmotionKeyword.flag=value=='已排重'?'':1;
            getViewpoinEmotionKeywordData();
        };
        // $scope.refresh=function(){
        //     getEventSpreadEmotionMedia();
        // };
        // search_date
        //事件传播分析相关稿件
        function getEventPropRelateMenus(){
            $scope.data.currentPropRelate=0;
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventPropRelateManus, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.propRelateContribution=data.CONTENT.RESULT.PAGEITEMS;
                    $scope.propRelateContLen=data.CONTENT.RESULT.PAGEITEMS.length;
                    var md5=$scope.propRelateContribution[$scope.data.currentPropRelate].MD5TAG;
                    $scope.eventPropRelateQu.md5tag=md5;
                    $scope.eventPropProportion.md5=md5;
                    $scope.eventPropRelateMedia.md5=md5;
                    getEventPropRelateQu();
                    getEventPropProportion();
                }
            });
        }
        //事件传播分析-归属性质及首发媒体
        function getEventPropRelateMedia(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventPropRelateMedia, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.eventPropRelateMediaData=data;
                    $scope.eventPropOutData=$scope.eventPropRelateMediaData.map(function(v,k){
                        var obj={};
                        obj={
                            value:v.NUM,
                            name:v.CHANNEL
                        }
                        return obj;
                    });
                }
            });
        }
        //事件传播分析-渠道分类及主要传播渠道
        function getEventPropRelateQu(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventPropRelateQu, "GET").then(function(data) {
                $scope.mainPropRelate=[];
                if(angular.isDefined(data)){
                    angular.forEach(data,function(value,key){
                        if(key=='MAINCHANNEL'){
                            return;
                        }else{
                            $scope.mainPropRelate.push({name:key,value:value});
                        }
                    });
                    if($scope.status.isFirstLoad){
                        $scope.eventPropRelateMedia.channel = $scope.status.mediaChannel[$scope.mainPropRelate[0].name];
                    }
                    getEventPropRelateMedia();
                    $scope.ProRelateQu=data;
                    $scope.mediaQuDao=$scope.ProRelateQu.MAINCHANNEL.replace(/\"/g,"");
                }
            });
        }
        //事件传播分析-声量占比
        function getEventPropProportion(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.eventPropProportion, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.ePropProportionData=data.replace(/\"/g,"");
                }
            });
        }
        //事件情感分析
        $scope.$on("changeEmotionTimeRangeData",function(event,value){
            var timeValue=value.timeValue;
            var staTime=$filter('date')(new Date(timeValue.startValue), 'yyyy-MM-dd');
            var endTime=$filter('date')(new Date(timeValue.startValue), 'yyyy-MM-dd');
            if(staTime== $scope.emotionTimeStartTime&&endTime==$scope.emotionTimeEndTime){
                return;
            }
            $scope.emotionTimeStartTime=staTime;
            $scope.emotionTimeEndTime=endTime;
            var searchDate= $scope.emotionTimeStartTime
                +';'+$scope.emotionTimeEndTime;
            $scope.eventSpreadKeyword.search_date=searchDate;
            $scope.eventSpreadEmotionMedia.search_date=searchDate;
            $scope.emotionChangeStrTime= $filter('date')(new Date(timeValue.startValue), 'MM-dd');
            $scope.emotionChangEndTime=$filter('date')(new Date(timeValue.endValue), 'MM-dd');
            getEventSpreadKeyword();
            getEventSpreadEmotionMedia();
        });
        //事件情感分析-情感变化关键词
        function getEventSpreadKeyword(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventSpreadKeyword, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.spreadKeyword=data.splice(0,7);
                }
            });
        }
        //事件情感分析-情感主导媒体
        function getEventSpreadEmotionMedia(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventSpreadEmotionMedia, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.spreadEmotionMedia=data.CONTENT.RESULT;
                }
            });
        }
        //事件观点分析
        //事件分类导航条
        $scope.selectedViewPointer=function(index,categoryName){
            $scope.status.selectedViewPointerIndex=index;
            $scope.eventViewpointEntity.category=categoryName;
            $scope.eventViewpointEntityArticle.category=categoryName;
            getEventViewpointEntity();
        };
        //观点分析
        $scope.$on("changeTypeData",function(event,value){
            var type=value.type;
            $scope.viewpoinTransport.type=type;
            $scope.viewpoinEmotionKeyword.type=type;
            $scope.viewpoinArticleRank.type=type;
            $scope.viewpoinSpreadData.type=type;
            $scope.viewpoinSZMedia.type=type;
            $scope.viewpoinDetonateGuide.type=type;
            $scope.viewpoinPeakTime.type=type;
            getViewpoinTransport();
            getViewpoinEmotionKeywordData();
            getViewpoinArticleRankData();
            getviewpoinSpreadData();
            getViewpoinSZMediaData();
            getViewpoinDetonateGuideData();
            getViewpoinPeakTime();
        });
        // 事件观点分析-事件观点转载量统计曲线图
        function getViewpoinTransport(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinTransport, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinTransportData=angular.fromJson(JSON.parse(data));
                }
            });
        }
        // 观点分析-情感变化关键词
        function getViewpoinEmotionKeywordData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinEmotionKeyword, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinEmotionKeywordData=data.splice(0,9);
                }
            });
        }
        // 观点分析-传播数据结果分析-主要渠道
        function getviewpoinSpreadData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),   $scope.viewpoinSpreadData, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinSpreadD=data;
                }
            });
        }
        // 观点分析-传播数据结果分析-主力媒体
        function getViewpoinSZMediaData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinSZMedia, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinSZMediaData=data;
                }
            });
        }
        // 观点分析-传播数据结果分析-引爆观点
        function getViewpoinDetonateGuideData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinDetonateGuide, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinDetonateGuideData=data;
                }
            });
        }
        // 观点分析-传播数据结果分析-峰值时间
        function getViewpoinPeakTime(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),   $scope.viewpoinPeakTime, "GET").then(function(data) {
                if(data){
                    var peakTime=data.replace(/\\["]/g,"");
                    var time=$filter('date')(new Date(peakTime), 'yyyy-MM-dd');
                    if(time=='Invalid Date'){
                        $scope.viewpoinPeakTimeData="-";
                    }else{
                        $scope.viewpoinPeakTimeData= $filter('date')(new Date(peakTime), 'yyyy-MM-dd');
                    }
                }
            });
        }
        // 观点分析-观点文章排行
        function getViewpoinArticleRankData(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.viewpoinArticleRank, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.viewpoinArticleRankData=data;
                }
            });
        }
        //事件观点分析-对应导航下的实体排序
        function getEventViewpointEntity(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventViewpointEntity, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    var arr=[];$scope.viewpointEntityArr=[];$scope.viewpointEntityNewArr=[];
                    $scope.viewpointEntity= angular.fromJson(JSON.parse(data));
                    if($scope.viewpointEntity.length>0){
                        $scope.viewpointEntity=$scope.viewpointEntity;
                        for(var i=0;i<$scope.viewpointEntity.length;i++){
                            $scope.viewpointEntity[i][0].date=$filter('date')(new Date($scope.viewpointEntity[i][0].date), 'MM-dd');
                            arr= $scope.viewpointEntity[i][1].data.split(";");
                            for(var j=0;j<10;j++){
                                if(arr[j]==undefined||arr[j]==''){
                                    arr[j]='—';
                                }
                            }
                            $scope.viewpointEntityArr.push({value:arr});

                        }
                        for(var i=0;i< 10;i++){
                            $scope.viewpointEntityNewArr[i]=[];
                        }
                        for(var i=0;i< $scope.viewpointEntityArr.length;i++){
                            for(var j=0;j< $scope.viewpointEntityArr[i].value.length;j++){
                                $scope.viewpointEntityNewArr[j][i]= $scope.viewpointEntityArr[i].value[j]
                            }
                        }
                    }
                }
            });
        }
        //点击查询对应实体文章
        $scope.showEntityArticle=function(value,field){
            if($scope.status.choiceKeyWord==value&&value!='—'){
                $state.go("front.plan.eventanalysis.newlist",{id:$scope.status.id,keyword:$scope.status.choiceKeyWord,field:field});
            }else{
                $scope.status.choiceKeyWord=value;
                if(!$scope.status.choiceKeyWord){
                    $scope.status.disabledEntityArticle=true;
                }else{
                    $scope.eventViewpointEntityArticle.entity=value;
                    $scope.status.currentPage=1;
                    $scope.status.choiceChannelInit=0;
                    getViewpointerArticleChannel().then(function(data){
                        $scope.eventViewpointEntityArticle.type=data[0].type;
                        eventViewpointEntityArticle();
                    });
                }
            }
        };
        $scope.hoverSameEntityArticle=function(value){
            $scope.hoverChoiceKeyWord=value;
        };
        $scope.hSameEntityArticle=function(value){
            $scope.hoverChoiceKeyWord='';
        };
        //事件观点分析-实体对应文章
        function eventViewpointEntityArticle(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),  $scope.eventViewpointEntityArticle, "GET").then(function(data) {
                if(angular.isDefined(data)) {
                    $scope.viewpointEntityArticle = data.PAGEITEMS;
                    $scope.status.totalPage = data.PAGETOTAL;
                    if ($scope.viewpointEntityArticle.length > 0) {
                        $scope.viewpointEntityArticleShow = true;
                    }
                }
            });
        }
        //对应文章上一页 下一页切换
        $scope.prevPage=function(){
            $scope.status.currentPage--;
            $scope.eventViewpointEntityArticle['page_no']=$scope.status.currentPage-1;
            eventViewpointEntityArticle();
        };
        $scope.nextPage=function(){
            if($scope.status.currentPage<$scope.status.totalPage){
                $scope.status.currentPage++;
            }
            $scope.eventViewpointEntityArticle['page_no']=$scope.status.currentPage-1;
            eventViewpointEntityArticle();
        };
        //获取观点分析占比数据
        function getViewPointerPro(){
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(),$scope.viewpointProportion, "GET").then(function(data) {
                if(angular.isDefined(data)){
                    $scope.data.viewpointPropData=data;
                    // 观点分析-事件观点转载量统计曲线图
                    getViewpoinTransport();
                    //观点分析-情感变化关键词
                    getViewpoinEmotionKeywordData();
                    // 观点分析-观点文章排行
                    getViewpoinArticleRankData();
                    // 观点分析-传播数据结果分析-主要渠道
                    getviewpoinSpreadData();
                    // 观点分析-传播数据结果分析-主力媒体
                    getViewpoinSZMediaData();
                    // 观点分析-传播数据结果分析-引爆观点
                    getViewpoinDetonateGuideData();
                    // 观点分析-传播数据结果分析-峰值时间
                    getViewpoinPeakTime();
                }
            });
        }
        //观点信息点击切换
        $scope.selectedGuideInfo=function(index,id,eventid){
            $scope.status.selectedGuideInfoIndex=index;
            if(!!eventid){
                $scope.viewpointProportion.slaveid=id;
                $scope.viewpoinTransport.slaveid=id;
                $scope.viewpoinDetonateGuide.slaveid=id;
                $scope.viewpoinPeakTime.slaveid=id;
                $scope.viewpoinEmotionKeyword.slaveid=id;
                $scope.viewpoinArticleRank.slaveid=id;
                $scope.viewpoinSpreadData.slaveid=id;
                $scope.viewpoinSZMedia.slaveid=id;
                $scope.viewpoinEmotionKeywordData=[];
                $scope.viewpoinManuscript.slaveid=id;
             }else{
                $scope.viewpointProportion.slaveid='';
                $scope.viewpoinTransport.slaveid='';
                $scope.viewpoinDetonateGuide.slaveid='';
                $scope.viewpoinPeakTime.slaveid='';
                $scope.viewpoinEmotionKeyword.slaveid='';
                $scope.viewpoinArticleRank.slaveid='';
                $scope.viewpoinSpreadData.slaveid='';
                $scope.viewpoinSZMedia.slaveid='';
                $scope.viewpoinManuscript.slaveid='';
            }
            getViewpoinManuscriptData();//观点稿件
            getViewPointerPro();
        };
        //相关稿件
        $scope.reducePropRelate=function(){
            $scope.data.currentPropRelate--;
            var md5=$scope.propRelateContribution[$scope.data.currentPropRelate].MD5TAG;
            $scope.eventPropRelateQu.md5tag=md5;
            $scope.eventPropProportion.md5=md5;
            $scope.eventPropRelateMedia.md5=md5;
            getEventPropRelateQu();
            getEventPropProportion();
        };
        $scope.addPropRelate=function(){
            $scope.data.currentPropRelate++;
            var md5=$scope.propRelateContribution[$scope.data.currentPropRelate].MD5TAG;
            $scope.eventPropRelateQu.md5tag=md5;
            $scope.eventPropProportion.md5=md5;
            $scope.eventPropRelateMedia.md5=md5;
            getEventPropRelateQu();
            getEventPropProportion();
        };
       $scope.getInfoPanelIndex=function(panelIndex){
           $scope.selectPanelIndex=panelIndex;
       };
        /**
         * [goRecentlyRank description] 近几日排名
         * @return {[type]}          [description]
         */
        $scope.goRecentlyRank=function(){
            var item={
                entity:$scope.status.choiceKeyWord,
                category:$scope.viewPointerAnaNav[$scope.status.selectedViewPointerIndex].STRVALUE,
            };
            eventAnalysisService.recentlyRank(item).then(function(){
            })
        }


    }]);